import { sortBy } from 'lodash';

// Shared with the signup modality step (`src/client/new/pages/auth/`). Both
// surfaces render this list as a chip picker against `Creator.keywords` and
// must stay in lockstep — any edit propagates to both automatically.
export const KEYWORD_LIMIT = 5;

export const PROFILE_KEYWORDS = sortBy([
  'Build muscle',
  'Weight loss',
  'Toning',
  'Shred fat',
  'Athletic',
  'Lean muscle',
  'Performance',
  '6-pack',
  'No equipment',
  'Bodyweight',
  'Home',
  'Beginner',
  'Mom',
  'Strength',
  'Conditioning',
  'Functional',
  'Mobility',
  'Flexibility',
  'Stretching',
  'Endurance',
  'Recovery',
  'Classes',
  'Crossfit',
  'Kettlebell',
  'Tabata',
  'Barre',
  'Pilates',
  'Yoga',
  'Boxing',
  'HIIT',
  'Cardio',
  'Pre/post natal',
  'Bikini Body',
  'Abs and Core',
  'Booty',
  'Full Body',
  'Celebrity',
  'Coaching',
  'Meditation',
  'Basketball',
  'Soccer',
  'Weight lifting',
]);
